import React from 'react';

export default class ChartBuilderRangeSelect extends React.Component {
  constructor(props) {
    super(props);
    this.rangeSelect = React.createRef();
  };

  componentDidMount() {
    this.initSelect2();
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.error) {
      $(`#select2-${this.props.detail.id}-range-container`).addClass('has-errors');
    } else {
      $(`#select2-${this.props.detail.id}-range-container`).hasClass('has-errors') ? $(`#select2-${this.props.detail.id}-range-container`).removeClass('has-errors') : null;
    };

  };

  componentWillUnmount() {
    $(this.rangeSelect.current).select2('destroy');
  }

  render() {
    return (
      [
        <select key={`${this.props.detail.id}-rang-select`} id={`${this.props.detail.id}-range`} name='x_range' ref={this.rangeSelect} className="form-control">
          <option></option>
        </select>,
        this.props.error
        ?
        <div className="help-block" key={`${this.props.detail.id}-rang-error-block`}>
          <ul>{I18n.t('cant_be_blank')}</ul>
        </div>
        :
        null
      ]
    );
  };

  initSelect2(){
  $(this.rangeSelect.current).select2({
    data: this.setRangeOptions(),
    allowClear: true,
    placeholder: I18n.t('select_ellipsis'),
  }).on('change.select2', (e) => {
    this.props.onChangeReportDetails(e);
  });
  }

  setRangeOptions() {
    return this.rangeOptionsSwitch();
  };

  rangeOptionsSwitch(){
    switch (true) {
      case this.props.report_details.x_grouping === 'days' && (this.props.detail.data_column_name === 'post_date' || this.props.detail.data_column_name === 'sent_date') : return [
        { id: 'last_seven_days', text: I18n.t('last_seven_days'), selected: this.props.report_details.x_range === 'last_seven_days', },
        { id: 'last_full_week', text: I18n.t('last_full_week'), selected: this.props.report_details.x_range === 'last_full_week', },
        { id: 'last_thirty_days', text: I18n.t('last_thirty_days'), selected: this.props.report_details.x_range === 'last_thirty_days', },
        { id: 'last_full_month', text: I18n.t('last_full_month'), selected: this.props.report_details.x_range === 'last_full_month', },
        { id: 'specific_dates', text: I18n.t('specific_dates'), selected: this.props.report_details.x_range === 'specific_dates', },
      ]
      case this.props.report_details.x_grouping === 'weeks' && this.props.detail.data_column_name === 'post_date': return [
        { id: 'last_three_months', text: I18n.t('last_three_months'), selected: this.props.report_details.x_range === 'last_three_months', },
        { id: 'last_full_quarter', text: I18n.t('last_full_quarter'), selected: this.props.report_details.x_range === 'last_full_quarter', },
        { id: 'specific_dates', text: I18n.t('specific_dates'), selected: this.props.report_details.x_range === 'specific_dates', },
      ]
      case this.props.report_details.x_grouping === 'months' && this.props.detail.data_column_name === 'post_date': return [
        { id: 'last_year', text: I18n.t('last_year'), selected: this.props.report_details.x_range === 'last_year', },
        { id: 'last_full_year', text: I18n.t('last_full_year'), selected: this.props.report_details.x_range === 'last_full_year', },
        { id: 'specific_dates', text: I18n.t('specific_dates'), selected: this.props.report_details.x_range === 'specific_dates', },
      ]
      // case this.props.report_details.x_grouping === 'days' && this.props.detail.data_column_name === 'sent_date': return [
      //   { id: 'last_seven_days', text: I18n.t('last_seven_days'), selected: this.props.report_details.x_range === '', },
      //   { id: 'last_full_week', text: I18n.t('last_full_week'), selected: this.props.report_details.x_range === '', },
      //   { id:'last_thirty_days', text: I18n.t('last_thirty_days'), selected: this.props.report_details.x_range === '',},
      //   { id: 'last_full_month', text: I18n.t('last_full_month'), selected: this.props.report_details.x_range === '',},
      //   { id: 'specific_dates', text: I18n.t('specific_dates'), selected: this.props.report_details.x_range === '',},
      // ]
      // case this.props.report_details.x_grouping === 'weeks' && this.props.detail.data_column_name === 'sent_date': return [
      //   { id: 'last_three_months', text: I18n.t('last_three_months'), selected: this.props.report_details.x_range === '', },
      //   { id: 'last_full_quarter', text: I18n.t('last_full_quarter'), selected: this.props.report_details.x_range === '', },
      //   { id: 'specific_dates', text: I18n.t('specific_dates'), selected: this.props.report_details.x_range === '', },
      // ]
      // case this.props.report_details.x_grouping === 'months' && this.props.detail.data_column_name === 'sent_date': return [
      //   { id: 'last_year', text: I18n.t('last_year'), selected: this.props.report_details.x_range === '', },
      //   { id: 'last_full_year', text: I18n.t('last_full_year'), selected: this.props.report_details.x_range === '', },
      //   { id: 'specific_dates', text: I18n.t('specific_dates'), selected: this.props.report_details.x_range === '', },
      // ]
      case this.props.report_details.x_grouping === 'days' && (this.props.detail.data_column_name === 'item_date' || this.props.detail.data_column_name === 'data_source_date' || this.props.detail.data_column_name === 'scheduled_at'): return [
        { id: 'last_seven_days', text: I18n.t('last_seven_days'), selected: this.props.report_details.x_range === 'last_seven_days', },
        { id: 'last_full_week', text: I18n.t('last_full_week'), selected: this.props.report_details.x_range === 'last_full_week', },
        { id: 'last_thirty_days', text: I18n.t('last_thirty_days'), selected: this.props.report_details.x_range === 'last_thirty_days', },
        { id: 'last_full_month', text: I18n.t('last_full_month'), selected: this.props.report_details.x_range === 'last_full_month', },
        { id: 'last_ninty_days', text: I18n.t('last_ninty_days'), selected: this.props.report_details.x_range === 'last_ninty_days', },
        { id: 'last_one_hundred_eighty_days', text: I18n.t('last_one_hundred_eighty_days'), selected: this.props.report_details.x_range === 'last_one_hundred_eighty_days', },
        { id: 'next_seven_days', text: I18n.t('next_seven_days'), selected: this.props.report_details.x_range === 'next_seven_days', },
        // { id: 'next_full_week', text: I18n.t('next_full_week'), selected: this.props.report_details.x_range === '', },
        { id: 'next_thirty_days', text: I18n.t('next_thirty_days'), selected: this.props.report_details.x_range === 'next_thirty_days', },
        { id: 'next_ninty_days', text: I18n.t('next_ninty_days'), selected: this.props.report_details.x_range === 'next_ninty_days', },
        { id: 'next_one_hundred_eighty_days', text: I18n.t('next_one_hundred_eighty_days'), selected: this.props.report_details.x_range === 'next_one_hundred_eighty_days', },
        // { id: 'next_full_month', text: I18n.t('next_full_month'), selected: this.props.report_details.x_range === '', },
        { id: 'specific_dates', text: I18n.t('specific_dates'), selected: this.props.report_details.x_range === 'specific_dates', },
      ]
      // case this.props.report_details.x_grouping === 'days' && (this.props.detail.data_column_name === 'scheduled_at' || this.props.detail.data_column_name === 'data_source_date'): return [
      //   { id: 'last_seven_days', text: I18n.t('last_seven_days'), selected: this.props.report_details.x_range === 'last_seven_days', },
      //   { id: 'last_full_week', text: I18n.t('last_full_week'), selected: this.props.report_details.x_range === 'last_full_week', },
      //   { id: 'last_thirty_days', text: I18n.t('last_thirty_days'), selected: this.props.report_details.x_range === 'last_thirty_days', },
      //   { id: 'last_full_month', text: I18n.t('last_full_month'), selected: this.props.report_details.x_range === 'last_full_month', },
      //   { id: 'next_seven_days', text: I18n.t('next_seven_days'), selected: this.props.report_details.x_range === 'next_seven_days', },
      //   // { id: 'next_full_week', text: I18n.t('next_full_week'), selected: this.props.report_details.x_range === '', },
      //   { id: 'next_thirty_days', text: I18n.t('next_thirty_days'), selected: this.props.report_details.x_range === 'next_thirty_days', },
      //   // { id: 'next_full_month', text: I18n.t('next_full_month'), selected: this.props.report_details.x_range === '', },
      //   { id: 'specific_dates', text: I18n.t('specific_dates'), selected: this.props.report_details.x_range === 'specific_dates', },
      // ]
      case this.props.report_details.x_grouping === 'weeks' && (this.props.detail.data_column_name === 'item_date' || this.props.detail.data_column_name === 'data_source_date'): return [
        { id: 'last_three_months', text: I18n.t('last_three_months'), selected: this.props.report_details.x_range === 'last_three_months', },
        { id: 'last_full_quarter', text: I18n.t('last_full_quarter'), selected: this.props.report_details.x_range === 'last_full_quarter', },
        { id: 'next_three_months', text: I18n.t('next_three_months'), selected: this.props.report_details.x_range === 'next_three_months', },
        { id: 'next_full_quarter', text: I18n.t('next_full_quarter'), selected: this.props.report_details.x_range === 'next_full_quarter', },
        { id: 'specific_dates', text: I18n.t('specific_dates'), selected: this.props.report_details.x_range === 'specific_dates', },
      ]
      case this.props.report_details.x_grouping === 'months' && (this.props.detail.data_column_name === 'item_date' || this.props.detail.data_column_name === 'data_source_date'): return [
        { id: 'last_year', text: I18n.t('last_year'), selected: this.props.report_details.x_range === 'last_year', },
        { id: 'last_full_year', text: I18n.t('last_full_year'), selected: this.props.report_details.x_range === 'last_full_year', },
        { id: 'next_year', text: I18n.t('next_year'), selected: this.props.report_details.x_range === 'next_year', },
        { id: 'next_full_year', text: I18n.t('next_full_year'), selected: this.props.report_details.x_range === 'next_full_year', },
        { id: 'specific_dates', text: I18n.t('specific_dates'), selected: this.props.report_details.x_range === 'specific_dates', },
      ]
      case (this.props.report_details.chart_type.name === 'vertical_bar_chart'): return [
        { id: 'last_thirty_days', text: I18n.t('last_thirty_days'), selected: this.props.report_details.x_range === 'last_thirty_days', },
        { id: 'last_full_month', text: I18n.t('last_full_month'), selected: this.props.report_details.x_range === 'last_full_month', },
        { id: 'last_three_months', text: I18n.t('last_three_months'), selected: this.props.report_details.x_range === 'last_three_months', },
        { id: 'last_full_quarter', text: I18n.t('last_full_quarter'), selected: this.props.report_details.x_range === 'last_full_quarter', },
        { id: 'next_thirty_days', text: I18n.t('next_thirty_days'), selected: this.props.report_details.x_range === 'next_thirty_days', },
        { id: 'next_full_month', text: I18n.t('next_full_month'), selected: this.props.report_details.x_range === 'next_full_month', },
        { id: 'next_three_months', text: I18n.t('next_three_months'), selected: this.props.report_details.x_range === 'next_three_months', },
        { id: 'next_full_quarter', text: I18n.t('next_full_quarter'), selected: this.props.report_details.x_range === 'next_full_quarter', },
        { id: 'specific_dates', text: I18n.t('specific_dates'), selected: this.props.report_details.x_range === 'specific_dates', },
      ]
    };
  }

};
